import { Box, FormControlLabel, Switch, TextField } from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  detailsTickets,
  setDetailsTicketValue,
  tripData,
} from 'src/redux/Calendar/sliceCalendar';
import ForwardIcon from '@material-ui/icons/Forward';
import { customFormat } from 'src/helpers/DateFormat';
import { IScheduleDetails } from 'src/redux/Calendar/interfaces';
import { normalizeTime } from 'src/helpers/calendar/normalizeTime';
import { useStyles } from './styles';

export const SchedulesUpdateForm = ({
  state,
  date,
  schedule_id,
}: {
  state: IScheduleDetails;
  date: string;
  schedule_id: string;
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const data = useSelector(tripData);
  const detailedData = useSelector(detailsTickets);
  const currentSchedule = data?.schedules.find((i) => i.id === +schedule_id);

  if (!currentSchedule) return null;

  const changeState = (name: string, value: any) => {
    if (!detailedData) return;

    dispatch(
      setDetailsTicketValue({
        schedule_id,
        date,
        name,
        value,
      })
    );
  };

  return (
    <Box borderBottom={'0.8px solid rgba(0, 0, 0, 0.12)'}>
      <Box
        py={1}
        px={3}
        display="flex"
        alignItems="center"
        fontSize="16px"
        bgcolor="#f5f5f5">
        <strong>{customFormat(date, 'MMMM DD YYYY')}</strong>
        &nbsp; ({state.sold || 0}&nbsp;sold,&nbsp;
        {(state.max_tickets
          ? +state.max_tickets
          : currentSchedule.max_tickets || 0) - +(state.sold || 0)}{' '}
        available) - &nbsp;
        <strong>
          {currentSchedule
            ? normalizeTime(currentSchedule.hour, currentSchedule.minute)
            : '-'}
        </strong>
      </Box>
      <Box
        display="flex"
        px={3}
        pb={2}
        pt={3}
        justifyContent="center"
        flexWrap="wrap"
        gridGap="10px">
        <Box mr={2} display="flex" alignItems="center">
          <TextField
            type="number"
            placeholder={currentSchedule?.min_tickets?.toString() || ''}
            value={state.min_tickets || ''}
            onChange={(e) => changeState('min_tickets', e.target.value)}
            variant="outlined"
            className={classes.inputWrapper}
            InputProps={{
              style: {
                width: '140px',
                height: '40px',
                background: '#fff',
              },
            }}
            inputProps={{
              min: 0,
              step: 1,
            }}
            size="small"
            InputLabelProps={{
              shrink: true,
              style: {
                letterSpacing: '0.04em',
              },
            }}
            label="Min Tickets"
          />
          <Box style={{ opacity: 0 }} display="flex">
            <ForwardIcon style={{ rotate: '90deg' }} />
          </Box>
        </Box>
        <Box mr={2} display="flex" alignItems="center">
          <TextField
            type="number"
            placeholder={currentSchedule?.max_tickets?.toString() || ''}
            value={state.max_tickets || ''}
            onChange={(e) => changeState('max_tickets', e.target.value)}
            variant="outlined"
            className={classes.inputWrapper}
            InputProps={{
              style: {
                width: '140px',
                height: '40px',
                background: '#fff',
              },
            }}
            inputProps={{
              min: 0,
              step: 1,
            }}
            size="small"
            InputLabelProps={{
              shrink: true,
              style: {
                letterSpacing: '0.04em',
              },
            }}
            label="Max Tickets"
          />
          <Box style={{ opacity: 0 }} display="flex">
            <ForwardIcon style={{ rotate: '90deg' }} />
          </Box>
        </Box>
        <Box display="flex">
          <Box display="flex" alignItems="center" mr={4} ml={6}>
            <FormControlLabel
              control={<Switch className={classes.customSwitch} />}
              label="Disable"
              checked={Boolean(state.is_disabled && +state.is_disabled)}
              onChange={(_, checked) =>
                changeState('is_disabled', checked ? '1' : '0')
              }
            />
            <Box style={{ opacity: 0 }} display="flex">
              <ForwardIcon style={{ rotate: '90deg' }} />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
